import { useAuthContext } from '@providers/AuthProvider';

import { routes } from '@routes';
import { Link as RouterLink } from 'react-router-dom';
import ChevronLeftIcon from '@components/icons/ChevronLeft.svg';
import { AdminCard } from './components/AdminCard';

export const WelcomeAdmin = () => {
  const { organization } = useAuthContext();
  return (
    <div className="w-full">
      <div className="border-divider border-t w-11/12 m-auto h-px pb-2" />
      <RouterLink
        to={routes.dashboard.make(organization?.slug ?? '')}
        className="text-foreground-muted flex gap-[11px] items-center no-underline text-xs font-medium leading-[130%] py-[15px] px-[11px]"
      >
        <ChevronLeftIcon className="h-[18px]" />
        Back to the Organization
      </RouterLink>

      <div className="pb-[15px]">
        <AdminCard />
      </div>
    </div>
  );
};
